import isEmpty from 'is-empty';

const roboAdvisoryValidateInputPhaseOne = (data) => {
  const errors = {};
  console.log('data.whenToStartWithdrawingMoney :', data.whenToStartWithdrawingMoney);
  if (!data.whenToStartWithdrawingMoney) {
    errors.whenToStartWithdrawingMoney = 'This field is required.';
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
};

const roboAdvisoryValidateInputPhaseTwo = (data) => {
  console.log('i got here ooo');
  const errors = {};
  if (!data.whenToStartSpendingMoney) {
    errors.whenToStartSpendingMoney = 'This field is required.';
  }
  return {
    errors,
    isValid: isEmpty(errors)
  };
};

const roboAdvisoryValidateInputPhaseThree = (data) => {
  const errors = {};
  if (!data.knowledgeOfInvestment) {
    errors.knowledgeOfInvestment = 'This field is required.';
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
};

const roboAdvisoryValidateInputPhaseFour = (data) => {
  const errors = {};

  if (!data.investmentConcern) {
    errors.investmentConcern = 'This field is required.';
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
};

const roboAdvisoryValidateInputPhaseFive = (data) => {
  const errors = {};

  if (!data.currrentlyOwnInvestment) {
    errors.currrentlyOwnInvestment = 'This field is required.';
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
};

const roboAdvisoryValidateInputPhaseSix = (data) => {
  const errors = {};

  if (!data.investmentLoosingValue) {
    errors.investmentLoosingValue = 'This field is required.';
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
};

const roboAdvisoryValidateInputPhaseSeven = (data) => {
  const errors = {};

  if (!data.annualReturns) {
    errors.annualReturns = 'This field is required.';
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
};

export {
  roboAdvisoryValidateInputPhaseOne,
  roboAdvisoryValidateInputPhaseTwo,
  roboAdvisoryValidateInputPhaseThree,
  roboAdvisoryValidateInputPhaseFour,
  roboAdvisoryValidateInputPhaseFive,
  roboAdvisoryValidateInputPhaseSix,
  roboAdvisoryValidateInputPhaseSeven
};
